import script from "./ChatAvatarModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatAvatarModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChatAvatarModal.vue?vue&type=style&index=0&id=5e89e1bf&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e89e1bf"]])

export default __exports__